import Vue from 'vue';
import Modal from 'components/project/analysis/results/Modal.vue';
import { BfButton, BfTextInput } from 'components/Butterfly';
import { Form, Field, } from 'components/forms';
import ProjectAPI from 'src/api/project';
import AlertsAPI from 'src/api/alerts';
const initialFormValues = {
    dashboard: undefined,
    title: '',
    description: '',
};
const AlertsModal = Vue.extend({
    components: {
        BfTextInput,
        BfButton,
        Field,
        Modal,
        Form,
    },
    props: {
        dashboardId: { type: Number, required: false, default: null },
    },
    data() {
        return {
            formValues: { ...initialFormValues },
            form: null,
            currentID: null,
            dashboards: [],
            visible: false,
        };
    },
    computed: {
        editMode() {
            return this.dashboardId == null && this.currentID != null;
        },
    },
    watch: {
        async visible(value) {
            if (!value) {
                // Delay until after closing animation
                setTimeout(() => {
                    this.reset();
                    this.currentID = null;
                    this.dashboards = [];
                }, 250);
            }
            else {
                if (!this.editMode) {
                    const dashboards = await ProjectAPI.getDashboards();
                    this.dashboards = dashboards.results;
                }
            }
        },
    },
    methods: {
        reset(values = initialFormValues) {
            this.formValues = { ...values };
            this.form?.resetForm(this.formValues);
        },
        open(id, data) {
            this.currentID = id;
            this.visible = true;
            this.$nextTick(() => {
                this.reset(data);
            });
        },
        close() {
            this.visible = false;
        },
        async submit(values) {
            const payload = {
                title: values.title,
                description: values.description ?? '',
                recipients: [],
            };
            if (this.editMode) {
                await AlertsAPI.updateAlert({
                    ...payload,
                    id: this.currentID,
                });
            }
            else {
                await AlertsAPI.createAlert({
                    ...payload,
                    dashboard: values.dashboard,
                });
            }
            this.$emit('update');
        },
    },
});
export default AlertsModal;
